import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  cases: [],
  currentCase: null,
  isLoading: false,
  error: null,
  pagination: {
    page: 1,
    limit: 20,
    total: 0,
  },
};

const caseSlice = createSlice({
  name: 'case',
  initialState,
  reducers: {
    fetchCasesStart: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    fetchCasesSuccess: (state, action) => {
      state.isLoading = false;
      state.cases = action.payload.data || action.payload;
      if (action.payload.pagination) {
        state.pagination = action.payload.pagination;
      }
    },
    fetchCasesFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    setCurrentCase: (state, action) => {
      state.currentCase = action.payload;
    },
    clearCurrentCase: (state) => {
      state.currentCase = null;
    },
    updateCaseStatus: (state, action) => {
      const { id, status } = action.payload;
      const caseItem = state.cases.find(c => c.id === id);
      if (caseItem) caseItem.status = status;
      if (state.currentCase?.id === id) state.currentCase.status = status;
    },
  },
});

export const {
  fetchCasesStart,
  fetchCasesSuccess,
  fetchCasesFailure,
  setCurrentCase,
  clearCurrentCase,
  updateCaseStatus,
} = caseSlice.actions;

export default caseSlice.reducer;